export default __webpack_public_path__ + "static/media/ltpplus_logo.931237e8.png";